/**
 * v7 §28 title-bar accessory: Test mode / Live on every main screen
 * (except Add rule, Settings, Help). Plan page uses plan name instead.
 */
export type AppPhase = "draft" | "test" | "live";

export function phaseFromStatus(opts: {
  published: boolean;
  paused: boolean;
}): AppPhase {
  if (!opts.published) return "draft";
  return opts.paused ? "test" : "live";
}

export function PhaseBadge({ phase }: { phase: AppPhase }) {
  if (phase === "live") {
    return (
      <s-badge slot="accessory" tone="success">
        Live
      </s-badge>
    );
  }
  if (phase === "draft") {
    return <s-badge slot="accessory">Not published</s-badge>;
  }
  return (
    <s-badge slot="accessory" tone="warning">
      Test mode
    </s-badge>
  );
}

export function PlanAccessoryBadge({ label }: { label: string }) {
  return <s-badge slot="accessory">{label}</s-badge>;
}
